import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import {
  ConstructorFieldGroupType,
  ConstructorFieldType,
  ConstructorWithHeaderFieldType,
  DominantEnum,
  OneConstructorFieldType
} from '../schema';

import { useConstructor } from './use-constructor';

export function useConstructorFields() {
  const {
    createOrUpdate: { dominant }
  } = useConstructor();

  const initial: { data: ConstructorFieldType } = {
    data: {}
  };

  const { data = initial, ...arg } = useQuery<
    { data: ConstructorFieldType },
    unknown,
    { data: ConstructorFieldGroupType }
  >(
    ['constructor-action-fields', dominant],
    async () => {
      const { data } = await $api.get(`/v1/excel-constructor/custom-template/example?dominant=${dominant}`);

      return { data: data?.data };
    },
    {
      select: ({ data }) => {
        // @ts-expect-error
        let result: ConstructorFieldGroupType = {};

        Object.keys(data)?.forEach(key => {
          const item = data[key as keyof typeof data];

          if (key?.includes('Header')) {
            const { columnDominant } = item as OneConstructorFieldType;

            if (Array.isArray(item)) {
              item?.forEach((customField, i) => {
                const childColumnDominant = (customField as OneConstructorFieldType)?.columnDominant;

                result = {
                  ...result,
                  [childColumnDominant]: [
                    ...(result[childColumnDominant as DominantEnum] || []),
                    { ...customField, headerKey: `${key}_${i}` }
                  ]
                };
              });
            } else {
              result = {
                ...result,
                [columnDominant]: [
                  ...(result[columnDominant as DominantEnum] || []),
                  { ...(item as ConstructorWithHeaderFieldType), headerKey: key }
                ]
              };
            }
          } else {
            result = { ...result, [key]: item };
          }
        });

        return { data: result };
      }
    }
  );

  return { ...data, ...arg };
}
